import { Trans, t } from '@lingui/macro';

import { AppButton, ConfirmationModal, TextInput, Version } from '@/UI';
import Success from '@/assets/icons/success.svg';

import classes from './ResetPassword.module.css';
import useResetPassword from './useResetPassword';

const ResetPassword = () => {
    const { modalVisible, onCancelModal, handleReset, onChange, email } =
        useResetPassword();

    return (
        <>
            <div className={classes['inputWrapper']}>
                <TextInput
                    name="email"
                    placeHolder={t`Enter Your Email`}
                    label={t`Email`}
                    onChange={onChange}
                    error={email.error}
                />
            </div>
            <AppButton
                classStyles={classes['btn']}
                title={t`Reset Password`}
                onClick={handleReset}
            />
            <ConfirmationModal
                visible={modalVisible}
                onCancel={onCancelModal}
                title={t`Reset Password`}
                description={t`Email is sent with reset link \n You are being redirected to Login`}
                rightOnClick={onCancelModal}
                rightButtonTitle={<Trans>login page</Trans>}
                icon={Success}
            />
        </>
    );
};

export default ResetPassword;
